'use client';

import { Box, useMergedRef } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useStickyNavigation } from './index.hook';
import classes from './index.module.scss';
// import { MainNavigationBar, MessageBanner, UtilityBar } from './subcomponents';
import { MainNavigationBar } from './subcomponents/MainNavigationBar';
import { UtilityBar } from './subcomponents/UtilityBar';
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import { getConfig } from "@/constants/config";
import _get from "lodash/get";
import { selectFavoritesState } from "@/store/features/favoritesSlice";
import { profileBrandSearch, profileServicePartsSearch, profileBrandTypeahead } from "@/store/features/productListSlice";
import { setSearchPresetConfig } from "@/store/features/searchSlice";
import { selectAuthState, setAuthModalVisibility } from "@/store/features/authSlice";
import { getUserPersona, getPDPUrl, sanitizeTextForAnalytics, getShortenedUrl, sanitizeUrl, getFavouraties, getCompareData, removeAndCleanLink } from "@/utils/helper";
import { addToCompareProduct, removeFromCompareProduct } from "@/utils/product";
import { getPdpRedirectUrl } from "@/utils/";
import { handleSearchAnalyticsEvent } from "@/components/Default/DynamicSearch/v1/analytics";
import debounce from "lodash.debounce";
import PromoBanner from './subcomponents/PromoBanner/promoBanner';

const SearchPanel = dynamic(() =>
  import("@/components/Default/DynamicSearch/v1/SearchPanel")
);

const MainMenu = React.forwardRef((props, ref) => {
  const {
    className,
    infoBanner,
    globalBanner,
    mainNavigation,
    utilityBar,
    promoBanner,
    storeMenu,
    loginMenu,
    languageMenu,
    mod,
    style,
    ...rest
  } = props;
  const classNames = clsx(classes.mainMenu, className, 'kohler-main-menu-root');
  const [menuType, setMenuType] = useState(null);
  const [mainMenuHeight, setMainMenuHeight] = useState(0);
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const mainMenuWrapperRef = useRef(null);
  const mainNavigationRef = useRef(null);
  const composeMainMenuWrapperRef = useMergedRef(mainMenuWrapperRef, ref);

  const { showStickyNav, isSticky } = useStickyNavigation(mainMenuHeight, mainNavigation?.isAlwaysSticky);
  const [firstStickyApplied, setFirstStickyApplied] = useState(false);

  // --- SearchPanel state and logic (copied from UtilityWidgets.jsx) ---
  const dispatch = useDispatch();
  const persona = getUserPersona();
  const currencySign = useRef("");
  const currencyCode = useRef("");
  const searchPagePath = useRef("");
  const knowledgeArticleUrl = useRef("");
  const [showSearch, setShowSearch] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchString, setSearchString] = useState("");
  const [searchHistory, setSearchHistory] = useState(
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("keyWordList")) ?? []
      : []
  );
  const [brandName, setBrandName] = useState("kohler");
  const [searchTotal, setSearchTotal] = useState(0);
  const [topSuggestedData, setTopSuggestedData] = useState("");
  const [isCTAClicked, setIsCTAClicked] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [category, setCategory] = useState("");
  const [tilesData, setTilesData] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const [xfLink, setXfLink] = useState("");
  const [promoLayout, setPromoLayout] = useState("one-column");
  const [isGlobalConfigBlank, setIsGlobalConfigBlank] = useState(true);
  const [fusionFullCatalogResponse, setFusioFullCatalognResponse] = useState([]);
  const [isSterling, setIsSterling] = useState(false);
  const [redirectTileToKohelerPLP, setRedirectTileToKohelerPLP] = useState("");
  const selectedFavoritesState = useSelector(selectFavoritesState);
  const { favorites } = selectedFavoritesState || {};
  const { lineItems = [] } = favorites || {};
  const { isAuth } = useSelector(selectAuthState);
  const [presetConfigs, setPresetConfigs] = useState(null);

  useEffect(() => {
    if (showSearch) {
      setSearchHistory(
        typeof window !== "undefined"
          ? JSON.parse(localStorage.getItem("keyWordList")) ?? []
          : []
      );
    }
  }, [showSearch]);

  useEffect(() => {
    if (isGlobalConfigBlank) {
      getConfig()
        .then(async config => {
          let blankConfig = false;
          if (!(config && Object.keys(config).length > 1)) {
            blankConfig = true;
            setIsGlobalConfigBlank(true);
          }
          let presetConfigs = await _get(config, "presetConfigs.search", "");
          setPresetConfigs(JSON.stringify(presetConfigs));
          
          if (!blankConfig) {
            setIsGlobalConfigBlank(false);
            const vbrandName = await _get(config, "general.siteName", "");
            if (vbrandName) {
              setBrandName(vbrandName);
            }
            currencySign.current = _get(config, "internationalization.currencySign", "");
            currencyCode.current = await _get(config, "internationalization.currencyCode", "");
            knowledgeArticleUrl.current = await getShortenedUrl(_get(config, "general.knowledgeArticlePath", ""));
            searchPagePath.current = await getShortenedUrl(_get(config, "general.searchPagePath", ""));
            setRedirectTileToKohelerPLP(
              await getShortenedUrl(_get(config, "general.searchPagePath", ""))
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }, [isGlobalConfigBlank]);

  useEffect(() => {
    if (props.data?.presetConfigs) {
      dispatch(setSearchPresetConfig(props.data.presetConfigs));
    }
  }, [props.data?.presetConfigs, dispatch]);

  const trackSearchSubmission = (
    searchTerm,
    status,
    message,
    internalLinkURL,
    analyticsEventType
  ) => {
    handleSearchAnalyticsEvent(
      status,
      message,
      internalLinkURL,
      analyticsEventType,
      internalLinkURL,
      {},
      searchTerm,
      searchTotal,
      topSuggestedData,
      searchHistory,
      brandName
    );
  };

 const handleRedirect = (
    searchTerm,
    isAnalyticsClick,
    analyticsEventType,
    isserachButton,
    topSuggestedData
  ) => {
    setProductsLoaded(false)
    setIsCTAClicked(true)
    if (redirectUrl) {
      if (isAnalyticsClick) {
        trackSearchSubmission(
          searchTerm,
          "success",
          null,
          redirectUrl,
          analyticsEventType
        )
      }
      window.location.href = redirectUrl
      setRedirectUrl("")
    } else {
      let history = JSON.parse(window.localStorage.getItem("keyWordList")) ?? []
      history = history.filter(
        item => item.keyWord.toLowerCase() !== searchTerm.toLowerCase()
      )
      history.unshift({ keyWord: searchTerm, id: Date.now() })
      window.localStorage.setItem("keyWordList", JSON.stringify(history))
      Promise.all([
        dispatch(
          profileBrandSearch([
            searchTerm.trim(),
            brandName.toLowerCase(),
            "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
            1,
            "",
          ])
        ),
      ])
        .then(async res => {
          if (res[0].payload) {
            let redirectUrl = ""
            // redirect if redirect URL is configured in LW for search keyword
            if (
              res[0].payload.fusion &&
              res[0].payload.fusion.redirect &&
              res[0].payload.fusion.redirect[0]
            ) {
              redirectUrl = res[0].payload.fusion.redirect[0]
              if (isAnalyticsClick) {
                trackSearchSubmission(
                  searchTerm,
                  "success",
                  null,
                  redirectUrl,
                  analyticsEventType
                )
              }
              window.location.href = redirectUrl
            } // get PDP / article URL if only 1 result
            else if (
              res[0].payload.response.numFound === 1 &&
              res[0].payload.fusion.exactMatch
            ) {
              const d = res[0].payload.response.docs[0]
              if (d.slug_s) {
                const param = d.sku_s ? `skuId=${d.sku_s}` : ""
                const pdpUrl = await getPDPUrl(d.Product_Category, d.slug_s)
                redirectUrl = getPdpRedirectUrl(pdpUrl, param)
              } else if (d.url_s) {
                redirectUrl = d.url_s
              }

              if (isAnalyticsClick) {
                trackSearchSubmission(
                  searchTerm,
                  "success",
                  null,
                  redirectUrl,
                  analyticsEventType
                )
              }
              window.location.href = redirectUrl
            }
            else {
              redirectUrl = sanitizeUrl(
                window.location.origin +
                  removeAndCleanLink(searchPagePath.current) +
                  `?keyword=${encodeURIComponent(searchTerm.trim())}`
              )
              if (isAnalyticsClick) {
                trackSearchSubmission(
                  searchTerm,
                  "success",
                  null,
                  redirectUrl,
                  analyticsEventType
                )
              }
              window.location.href = redirectUrl
            }
          }
        })
        .catch(err => {
          console.log("Error occured while fetching Search data", err)
          if (isAnalyticsClick) {
            trackSearchSubmission(
              searchTerm,
              "failure",
              "error occured while fetching search data",
              redirectUrl,
              analyticsEventType
            )
          }
          setProductsLoaded(true)
        })
    }
  };

  const handleDelete = id => {
    let history = JSON.parse(window.localStorage.getItem("keyWordList")) ?? [];
    history = history.filter(item => item.id !== id);
    window.localStorage.setItem("keyWordList", JSON.stringify(history));
    setSearchHistory(history);
  };

  const handleClearAll = () => {
    localStorage.removeItem("keyWordList");
    setSearchHistory([]);
  };

  const handleChange = searchTerm => {
    setProductsLoaded(false);
    setSearchString(searchTerm.trim());
  };

  useEffect(() => {
    if (brandName) {
      if (searchString.length >= 3) {
        getSearchResult(searchString);
      } else {
        setSearchTotal(0);
      }
      setProductsLoaded(false);
    }
  }, [searchString, brandName]);

  const getSearchResult = useCallback(
    debounce(searchString => getData(searchString), 2000),
    [brandName]
  );

  const getData = searchStr => {
    if (redirectUrl) setRedirectUrl("");
    if (!isCTAClicked && searchStr.length >= 3) {
      Promise.all([
        dispatch(
          profileBrandSearch([
            searchStr.trim(),
            brandName.toLowerCase(),
            "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
            1,
            "",
          ])
        ),
        dispatch(
          profileBrandTypeahead([searchStr.trim(), brandName.toLowerCase()])
        ),
      ])
        .then(async res => {
          if (res[0].payload && res[1].payload) {
            let redirectUrl = "";
            if (
              res[0].payload.fusion &&
              res[0].payload.fusion.redirect &&
              res[0].payload.fusion.redirect[0]
            ) {
              window.location.href = res[0].payload.fusion.redirect[0];
            }
            else if (
              res[0].payload.response.numFound === 1 &&
              res[0].payload.fusion.exactMatch
            ) {
              const d = res[0].payload.response.docs[0];
              if (d.slug_s) {
                const param = d.sku_s ? `skuId=${d.sku_s}` : "";
                const pdpUrl = await getPDPUrl(d.Product_Category, d.slug_s);
                redirectUrl = getPdpRedirectUrl(pdpUrl, param);
              } else if (d.url_s) {
                redirectUrl = d.url_s;
              }
            }

            if (!res[0].payload.fusion.redirect) {
              let groups = [
                {
                  key: "products",
                  fq: 'Products:("ct")',
                  count: _get(
                    res[0].payload,
                    "facet_counts.facet_fields.Products[1]",
                    0
                  ),
                },
                {
                  key: "technical",
                  fq: 'Technical:("ct")',
                  count: _get(
                    res[0].payload,
                    "facet_counts.facet_fields.Technical[1]",
                    0
                  ),
                },
                {
                  key: "inspiration",
                  fq: 'Inspiration:("Inspiration")',
                  count: _get(
                    res[0].payload,
                    "facet_counts.facet_fields.Inspiration[1]",
                    0
                  ),
                },
                {
                  key: "resource",
                  fq: 'Resource:("Resource")',
                  count: _get(
                    res[0].payload,
                    "facet_counts.facet_fields.Resource[1]",
                    0
                  ),
                },
                {
                  key: "help",
                  fq: 'Help:("sf")',
                  count: _get(
                    res[0].payload,
                    "facet_counts.facet_fields.Help[1]",
                    0
                  ),
                },
              ];
              let total = 0;
              const selected = groups.find(group => group.count > 0);
              if (
                res[0].payload.fusion.exactMatch
              ) {
                total =res[0].payload.response.numFound;
              } else {
                groups.forEach(group => (total += group.count));
              }
              setSearchTotal(total);
              setRedirectUrl(redirectUrl);
              const fullCatalogResponse = _get(
                res[0].payload,
                "fusion.full_catalog_Response",
                []
              );
              if (fullCatalogResponse.length > 0) {
                setIsSterling(true);
                setSearchTotal(1);
              }
              setFusioFullCatalognResponse(fullCatalogResponse);

              const responseDocs = _get(res[1].payload, "response.docs", []);
              setTopSuggestedData(
                fullCatalogResponse.length > 0
                  ? fullCatalogResponse
                  : responseDocs
              );

              setSelectedData(selected);
            }
          }
        })
        .catch(err => {
          setProductsLoaded(true);
          console.error("Error occured while fetching Search data", err);
        });
    } else {
      setSearchTotal(0);
      setCategory("");
      setTilesData([]);
      setRedirectUrl("");
      setTopSuggestedData([]);
    }
  };

  useEffect(() => {
    if (searchTotal > 0 && selectedData.key) {
      getTilesData(selectedData);
    }
  }, [searchTotal, selectedData]);

  const getTilesData = selected => {
    const fl = [
      "id",
      "sku_s",
      "slug_s",
      "metaTitle_s",
      "productName_s",
      "masterSKU_s",
      "Product_Category",
      "ProductBrandName_s",
      "productImages.url_ss",
      "displayPriceStartingAt_s",
      "SKUColorSwatchFilename_ss",
      "ProductDescriptionProductShort_s",
      "url_s",
      "title_s",
      "pageTitle_s",
      "eyeBrowText_s",
      "templateType_s",
      "thumbNailImage_s",
      "searchDescription_s",
      `priceList.${persona}.price_d`,
      `priceList.${persona}.finalPrice_d`,
      `priceList.${persona}.discountedPrice_d`,
      `priceList.${persona}.saleOffer_s`,
      `priceStartingAt.${persona}_d`,
      `discountedPriceStartingAt.${persona}_d`,
      "Color.SKU.Details_ss",
      `Color.${persona}.Details_ss`,
      "ProductIsExclusive_s",
      "RegionReleaseforShipment_dt",
      "RegionLaunchDate_dt",
      "productImages.labelWithUrl_ss",
      "variantList.sku_ss",
      "RegionOnBackOrder_s",
      "RegionBrandName_s",
      "ctId_s",
      "pdp_url_s",
      `Sale.${persona}.Details_ss`,
      "RegionAltUOM_s",
      "ItemCharacteristic.TYPE.CharacteristicDescription_s", 
      "ItemCharacteristic.TYPE.CharacteristicTypeDescriptionKey_s", 
      "ItemCharacteristic.TYPE.CharacteristicDescriptionUpperCase_s",
    ];
    setXfLink("");
    setPromoLayout("one-column");
    setCategory("");
    setTilesData([]);

    dispatch(
      selected.key === "parts"
        ? profileServicePartsSearch([searchString.trim(), fl.join(","), 6])
        : profileBrandSearch([
          searchString.trim(),
          brandName.toLowerCase(),
          fl.join(","),
          6,
          selected.fq,
        ])
    ).then(res => {
      if (res.payload && res.payload.response?.docs) {
        setCategory(selected.key);
        setTilesData(res.payload.response?.docs);
        if (fusionFullCatalogResponse?.length > 0) {
          setTilesData(fusionFullCatalogResponse);
        }
        if (
          res.payload.fusion &&
          res.payload.fusion.experiment_fragments &&
          res.payload.fusion.experiment_fragments !== undefined
        ) {
          setPromoLayout(
            res.payload.fusion?.experiment_fragments[0]?.promoLayout_s ?? "one-column"
          );
          setXfLink(res.payload.fusion?.experiment_fragments[0]?.url_s ?? "");
        }
      }
      setProductsLoaded(true);
    });
  };

  const bodyRef = useRef(typeof window !== "undefined" ? document.body : null);
  const htmlRef = useRef(
    typeof window !== "undefined"
      ? document.getElementsByTagName("html")[0]
      : null
  );
  const handleToggle = () => {
    setSearchString("");
    setSearchTotal(0);
    const classNames = ["searchbar-open", "scroll-lock"];
    classNames.map(className => bodyRef?.current?.classList?.toggle(className));
    classNames.map(className => htmlRef?.current?.classList?.toggle(className));
    setShowSearch(!showSearch);
  };

  // --- End SearchPanel logic ---

  useEffect(() => {
    if (isSticky && !firstStickyApplied) {
      setFirstStickyApplied(true);
    } else if (!isSticky && firstStickyApplied) {
      setFirstStickyApplied(false);
    }
  }, [isSticky, firstStickyApplied]);

  const disableTransition = isSticky && !firstStickyApplied;

  const typedUtilityBar = {
    ...utilityBar,
    storeMenu,
    loginMenu,
    languageMenu,
    menuType,
    setMenuType,
    setIsOpenMobileMenu: setOpenMobileMenu,
  };

  if (typedUtilityBar) {
    if (typedUtilityBar.languagePicker && languageMenu) {
      const originalOnClick = utilityBar?.languagePicker?.languagePickerCTA?.onClick;
      typedUtilityBar.languagePicker.languagePickerCTA.onClick = (e) => {
        if (originalOnClick) originalOnClick(e);
        setMenuType(menuType === 'language' ? null : 'language');
      };
    }
    if (typedUtilityBar.locationPickerCTA && storeMenu) {
      const originalOnClick = utilityBar?.locationPickerCTA?.onClick;
      typedUtilityBar.locationPickerCTA.onClick = (e) => {
        if (originalOnClick) originalOnClick(e);
        setMenuType(menuType === 'store' ? null : 'store');
      };
    }
    if (typedUtilityBar && loginMenu) {
      const originalOnClick = utilityBar?.userCTA?.onClick;
      typedUtilityBar.userCTA = utilityBar?.userCTA || {};
      typedUtilityBar.userCTA.onClick = (e) => {
        if (originalOnClick) originalOnClick(e);
        setMenuType(menuType === 'user' ? null : 'user');
      };
    }
  }

  useEffect(() => {
    if (mainMenuWrapperRef.current) {
      setMainMenuHeight(mainMenuWrapperRef.current.clientHeight);
    }
  }, []);

  useEffect(() => {
    if (mainNavigationRef.current) {
      const height = mainNavigationRef.current.clientHeight;
      document.body.style.setProperty('--main-menu-height', `${showStickyNav ? height : 0}px`);
    }
  }, [showStickyNav]);

  return (
    <Box
      component="header"
      ref={composeMainMenuWrapperRef}
      {...rest}
      className={classNames}
      mod={mod}
      style={{ '--main-menu-height': `${mainMenuHeight}px`, ...style }}
    >
      {/* {infoBanner && <MessageBanner type="info" {...infoBanner} />}
      {globalBanner && <MessageBanner type="global" {...globalBanner} />} */}
      {typedUtilityBar && (
        <UtilityBar
          {...typedUtilityBar}
          menuType={menuType}
          setMenuType={setMenuType}
          storeMenu={storeMenu}
          languageMenu={languageMenu}
          loginMenu={loginMenu}
          setIsOpenMobileMenu={setOpenMobileMenu}
        />
      )}
      {promoBanner && <PromoBanner promoBanner={promoBanner}/> }
      {mainNavigation && (
        <Box
          className={clsx(classes.mainNavigationBarWrapper, {
            [classes.fixedNav]: isSticky,
            [classes.showSticky]: showStickyNav,
            [classes.showBackgroundRelative]: mainNavigation.showBackground || mainNavigation.isStatic,
          })}
          style={disableTransition ? { transitionDuration: '0s' } : undefined}
        >
          <MainNavigationBar
            {...mainNavigation}
            searchCTA={{
              ...mainNavigation.searchCTA,
              onClick: handleToggle
            }}
            searchText="Search"
            utilityLinks={typedUtilityBar}
            setIsOpenMobileMenu={setOpenMobileMenu}
            openMobileMenu={openMobileMenu}
            ref={mainNavigationRef}
            showBackground={isSticky || mainNavigation.showBackground}
          />
        </Box>
      )}
      <div className="utilitywidgets">
        <div className="utility-widgets">
          <div className="search-widget">
     
            {showSearch && (
              <SearchPanel
                showSearchBar={showSearch}
                onToggle={handleToggle}
                onRedirect={handleRedirect}
                onChange={handleChange}
                searchString={searchString}
                brand={brandName}
                searchTotal={searchTotal}
                topSuggestedData={topSuggestedData}
                searchHistory={searchHistory}
                xfLink={xfLink}
                category={category}
                removeFromCompare={removeFromCompareProduct}
                addToCompare={addToCompareProduct}
                tilesData={tilesData}
                productsLoaded={productsLoaded}
                promoLayout={promoLayout}
                favorites={getFavouraties()?.lineItems}
                comparedProducts={getCompareData()}
                currencySign={currencySign.current}
                knowledgeArticleUrl={knowledgeArticleUrl.current}
                presetConfigs={`${presetConfigs}`}
                onDelete={handleDelete}
                onClearAll={handleClearAll}
                isSterling={isSterling}
                sterlingData={fusionFullCatalogResponse}
                parent={"Utility Widgets"}
                searchPagePath={redirectTileToKohelerPLP}
              />
            )}
          </div>
        </div>
      </div>

    </Box>
  );
});

export default MainMenu